<section class="section mt-60" *ngIf="!thanksPage" style="background-color: #FFFFFF;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-6 pt-2 pt-sm-0 order-2 order-md-1">
        <div class="card shadow rounded border-0">
          <div class="card-body">
            <h4 class="card-title">Register</h4>
            <div class="custom-form mt-3">
              <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-floating mb-2">
                      <input type="text" class="form-control"
                        [ngClass]="{ 'input-danger': validating.name.invalid && validating.name.touched}"
                        formControlName="name" id="floatingInput" placeholder="Your Full Name">
                      <label for="floatingInput">Your Full Name</label>
                      <small class="text-danger" *ngIf="validating.name.invalid && validating.name.touched">
                        is required
                      </small>
                    </div>

                    <div class="form-floating mb-2">
                      <input type="text" class="form-control"
                        [ngClass]="{ 'input-danger': validating.phone.invalid && validating.phone.touched}"
                        formControlName="phone" id="floatingInput" placeholder="Phone Number">
                      <label for="floatingInput">Phone Number</label>
                      <small class="text-danger" *ngIf="validating.phone.invalid && validating.phone.touched">
                        is required
                      </small>
                    </div>

                    <div class="form-floating mb-2">
                      <input type="email" class="form-control"
                        [ngClass]="{ 'input-danger': validating.email.invalid && validating.email.touched}"
                        formControlName="email" id="floatingInput" placeholder="Email">
                      <label for="floatingInput">Email</label>
                      <small class="text-danger" *ngIf="validating.email.invalid && validating.email.touched">
                        is required
                      </small>
                    </div>

                    <div class="form-floating mb-2">
                      <input type="password" class="form-control"
                        [ngClass]="{ 'input-danger': validating.password.invalid && validating.password.touched}"
                        formControlName="password" id="floatingInput" placeholder="Password">
                      <label for="floatingInput">Password</label>
                      <small class="text-danger" *ngIf="validating.password.invalid && validating.password.touched">
                        is required
                      </small>
                    </div>

                    <div class="form-floating mb-2">
                      <input type="password" class="form-control"
                        [ngClass]="{ 'input-danger': validating.passwordConfirmation.invalid && validating.passwordConfirmation.touched}"
                        formControlName="passwordConfirmation" id="floatingInput" placeholder="Password Confirmation">
                      <label for="floatingInput">Password Confirmation</label>
                      <small class="text-danger"
                        *ngIf="validating.passwordConfirmation.invalid && validating.passwordConfirmation.touched">
                        is required
                      </small>
                    </div>

                  </div>
                  <div class="col-12">
                    <div class="mb-3">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" [value]="1"
                          (change)="confirRegister($event)">
                        <label class="form-check-label" for="flexSwitchCheckDefault">
                          By registering, I accept the
                          <a href="javascript:void(0)" (click)="navigated('term-of-use')" class="color-brand">
                            Terms of Service</a> and <a href="javascript:void(0);" class="color-brand"
                            (click)="navigated('privacy-policy')">Privacy Policy</a>.
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-floating mb-2">
                      <ngx-recaptcha2 #captchaElem
                        [siteKey]="siteKey"
                        [useGlobalDomain]="true"
                        [size]="size"
                        [theme]="themecaptcha"
                        [type]="type"
                        formControlName="recaptcha">
                      </ngx-recaptcha2>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-grid">
                      <button type="submit" class="btn btn-primary" [disabled]="!confirmed || preloader">
                        <span *ngIf="preloader" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        Register
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <p>&nbsp;</p>
            Already register ? <a href="javascript:void(0)" class="color-brand fw-bold"
              (click)="navigated('/login')">Login
              here</a>
          </div>
        </div>
      </div>

      <div class="col-lg-7 col-md-6 order-1 order-md-2">
        <img src="assets/images/hosting/deal-hend.svg" class="img-fluid" alt="">
      </div>
    </div>
  </div>
</section>

<section class="bg-home bg-light d-flex align-items-center" *ngIf="thanksPage">
  <div class="container mt-100 mt-60">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-5 col-12">
        <img src="assets/images/illustrator/envelope.svg" class="img-fluid mx-auto d-block" alt="">
      </div>

      <div class="col-lg-7 col-md-7 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div class="section-title">
          <h4 class="title mb-4">Thank you <br> for registering your account.</h4>
          <p class="text-muted para-desc mb-0">Please check your email address in order to complete your registration and verification.</p>
          <div class="my-4">
            <a (click)="navigated('/')" class="btn btn-brand m-1">
              <i class='bx bx-left-arrow-alt'></i>
              Thank you!
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
